import CommentModerationContainer from './comment_moderation_container.js'
export default {
  CommentModerationContainer,
}
